export default "__VITE_ASSET__BQiVmDdl__"